import React, { useState, useEffect, useRef } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { getVendorDetail, getVendorDetailForTable } from "../../actions";
import VendorCode from "../Dropdowns/VenderCode";
import { Delete } from "@material-ui/icons";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import POAlertDialog from "./PoTableAlert";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import "./style.css";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  intColumn,
  resizeColumn,
  floatColumn,
} from "react-datasheet-grid";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

const Vendor_Table = ({
  formState,
  setFormState,
  disabled,
  required,
  // vendorList,
  // setVendorList,
  setDisablePostToSap,
  disablePostToSap
}) => {
  const tableData = {
    vendor_Code: "",
    vendor_Name: "",
    amount: "",
  };
  const classes = useStyles();
  const [vendorList, setVendorList] = useState([]);
  const [vendorListLoading, setVendorListLoading] = useState(false);
  const [vendorblock, setvendorblock] = useState(false);
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [vendorChoices, setVendorChoices] = useState([]);
  const [amountValue , setAmountValue] = useState(0)
  useEffect(() => {
    getVendorDetail("", setVendorList, setVendorListLoading);
  }, []);

  const SelectComponent = React.memo(
    ({ active, rowData, setRowData, focus, stopEditing, columnData }) => {
      const ref = useRef(null);
      //
      useEffect(() => {
        if (focus) {
          ref.current?.focus();
        } else {
          ref.current?.blur();
        }
      }, [focus]);
      const [choices, setChoices] = useState(columnData.choices);
      useEffect(() => {
        getVendorDetailForTable(
          rowData?.Vendor_Code,
          setChoices,
          setVendorListLoading
        );
        // getCostCenterDataByID(rowData);
      }, [rowData]);
      return (
        <>
          {/*{() => ( */}

          <FormControl fullWidth>
            <Autocomplete
              ref={ref}
              style={{ width: "100%" }}
              // value={rowData?.vendor_Code}
              value={
                rowData
                  ? choices.find(
                      (option) => option.value === rowData?.Vendor_Code
                    ) || {
                      value: "",
                      label: "",
                    }
                  : null
              }
              onChange={(event, newValue) => {
                const selectedVendor = newValue?.data || {};
                setRowData(selectedVendor);
                setTimeout(stopEditing, 0);

                if (
                  selectedVendor?.ALL_COMPANY_CODE === "X" &&
                  selectedVendor !== null
                ) {
                  setvendorblock(true);
                  setErrAlertMessage("This Vendor code has been Blocked");
                }
              }}
              options={choices}
              getOptionLabel={(option) => option?.label}
              disabled={disabled}
              loading={vendorListLoading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  size="small"
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  onChange={(event) => {
                    getVendorDetailForTable(
                      event.target.value,
                      setChoices,
                      setVendorListLoading
                    );
                  }}
                  required={required}
                />
              )}
            />
          </FormControl>
        </>
      );
    }
  );

  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      vendor_Details: [...formState?.vendor_Details, tableData],
    }));
  };

  const changeHandler = (e, index) => {
    const { name, value } = e.target;

    let tempArray = formState?.vendor_Details;
    tempArray[index] = {
      ...formState?.vendor_Details[index],
      [name]: value,
    };

    if (name === "vendor_Code") {
      let selectedItem = {};

      for (let i = 0; i < vendorList.length; i++) {
        const element = vendorList[i];

        if (element?.Vendor_Code === value?.Vendor_Code) {
          selectedItem = element;
          break;
        }
      }

      tempArray[index] = {
        ...formState?.vendor_Details[index],
        vendor_Name: selectedItem.Vendor_Name
          ? selectedItem.Vendor_Name
          : "Not Found",
      };
    }

    setFormState((formState) => ({
      ...formState,
      vendor_Details: tempArray,
    }));
  };
  const deleteInput = (index, rowId) => {
    const filteredData = formState?.vendor_Details?.filter(
      (x, i) => x?.rowId !== rowId
    );
    setFormState((formState) => ({
      ...formState,
      vendor_Details: filteredData,
    }));
  };
  const [cellState, setCellState] = useState("");

  const handleGridChange = async (newData, operation) => {
    let updateData = [];
    for (let j = 0; j < newData.length; j++) {
      const row = newData[j];
      let ab = { VendorData: "" };
      if (row?.vendor_Code) {
        await getVendorDetailForTable(
          row?.vendor_Code.Vendor_Code,
          ab,
          setVendorListLoading
        );
      }
      // row.vendor_Code = row?.vendor_Code ? row?.vendor_Code : "";
      row.vendor_Name = row?.vendor_Code
        ? ab.VendorData?.Vendor_Name
          ? ab.VendorData?.Vendor_Name
          : "No Found"
        : "";
      row.amount = row?.amount ? row?.amount : "";
      updateData.push(row);
    }
    // const updatedData = newData.map((row) => {

    //   const vendorName = row?.vendor_Code
    //     ? row?.vendor_Code.Vendor_Name
    //     : row?.vendor_Code
    //     ? "Not Found"
    //     : "";
    //   return {
    //     ...row,
    //     vendor_Code: row?.vendor_Code ? row?.vendor_Code : "",
    //     vendor_Name: vendorName,
    //     amount: row?.amount ? row?.amount : "",
    //   };
    // });

    setFormState((formState) => ({
      ...formState,
      // vendor_Details: parsedResult,
      vendor_Details: updateData,
    }));
  };

  // const intColumn = {
  //   component: AmountCell,
  //   disableKeys: true,
  //   keepFocus: true,
  //   deleteValue: () => "",
  //   copyValue: ({ rowData }) => rowData,
  //   pasteValue: ({ value }) => value,
  // };
  const selectColumn = (options) => ({
    component: SelectComponent,
    columnData: options,
    disableKeys: true,
    keepFocus: true,
    copyValue: ({ rowData }) => {
      // Return the Vendor_Code for copying
      return rowData.Vendor_Code;
    },
    pasteValue: ({ value, rowData, setRowData }) => {
      // Fetch the vendor details based on the pasted Vendor_Code

      // Set the Vendor_Code and Vendor_Name when pasting
      const updatedRowData = {
        ...rowData,
        Vendor_Code: value,
      };
      return updatedRowData;
    },
  });

  const columns = [
    {
      ...keyColumn(
        "vendor_Code",
        selectColumn({
          choices: vendorList?.map((vendor, i) => ({
            data: vendor,
            value: `${vendor.Vendor_Code}`,
            label: `${vendor.Vendor_Code} - ${vendor.Vendor_Name}`,
            // defaultChoices : [
            //   { value: `${vendor.Vendor_Code}`, label:  `${vendor.Vendor_Code} - ${vendor.Vendor_Name}` },

            // ]
          })),
        })
      ),
      title: "vendor Code",
      disabled: disabled,
    },
    {
      ...keyColumn("vendor_Name", textColumn),
      title: "Vendor Name",
      disabled: true,
    },
    // {
    //   title: "Amount",
    //   component: AmountCell

    //   // grow: 2,
    // },
    {
      ...keyColumn("amount" || "Amount", floatColumn),
      title: "Amount",
      minWidth: 160,
      disabled: disabled,
      pasteValue: ({ rowData, value, rowIndex }) => {
        rowData.amount = Number(value.replace(/,/g, "")) || 0;
        return rowData;
      },
    },
  ];
useEffect(()=>{
// const calculatedTotalAmount = formState?.vendor_Details?.reduce((sum, row) => sum + parseFloat(row.amount), 0)
const calculatedTotalAmount = formState?.vendor_Details?.reduce((sum, row) => 
  sum + (parseFloat(row.amount) || 0), 0
);

if(!isNaN(calculatedTotalAmount) ){
  setAmountValue(calculatedTotalAmount)
}
},[formState?.vendor_Details  ])
useEffect(()=>{
  if(formState?.invoice_Amount == amountValue){
   if(formState?.invoice_Amount > 0){
    if(disablePostToSap !== undefined){
  setDisablePostToSap(false)
    }
   }
  }
  else {
    if(disablePostToSap !== undefined){
    setDisablePostToSap(true)
    }
  }
},[amountValue , formState?.invoice_Amount])
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
        {/*<TableContainer className="scrollable">
          <Table
            size="small"
            aria-label="simple table"
            className={classes.table}
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  #
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Vendor Code
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Vendor Name{" "}
                </TableCell>

                <TableCell
                  style={{
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Amount
                </TableCell>
                {!disabled && (
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Action
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {formState?.vendor_Details?.map((item, index) => {
                return (
                  <TableRow style={{ width: "100%" }}>
                    <TableCell scope="row">{index + 1}</TableCell>

                    <TableCell sx={{ padding: "8px" }}>
                      <FormControl fullWidth size="small">
                        <VendorCode
                          disabled={disabled}
                          formState={item}
                          changeHandler={changeHandler}
                          user={null}
                          vendorCodeOnly={true}
                          index={index}
                          bordered={false}
                          setvendorblock={setvendorblock}
                          setErrAlertMessage={setErrAlertMessage}
                        />
                      </FormControl>
                    </TableCell>
                    <TableCell> {item?.vendor_Code?.Vendor_Name}</TableCell>

                    <TableCell sx={{ padding: "8px" }}>
                      <TextField
                        type="number"
                        name="amount"
                        size="small"
                        disabled={disabled}
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="standard"
                        value={item?.amount}
                        //  InputProps={{ disableUnderline: true }}
                        required
                        onChange={(event) => changeHandler(event, index)}
                      />
                    </TableCell>

                    {!disabled && (
                      <TableCell align="center">
                        <Delete
                          color="error"
                          onClick={() => {
                            deleteInput(index, item?.rowId);
                          }}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {formState?.vendor_Details?.length === 0 ? <EmptyData /> : ""}
            </TableContainer> */}
        {/* check vendorlist loaded or not */}
        {vendorList.length > 0 ? (
         <>
          <DataSheetGrid
            style={{
              "--dsg-header-text-color": "#031C30",
              "--dsg-cell-disabled-background-color": "031C30",
            }}
            // value={formState?.vendor_Details}
            onChange={handleGridChange}
            value={
              formState?.vendor_Details?.length === 0
                ? [tableData]
                : [
                    ...formState?.vendor_Details?.map((item) => {
                      const newItem = { ...item };
                      if (newItem.hasOwnProperty("amount")) {
                        newItem["amount"] = Number(
                          Number(newItem["amount"])?.toFixed(2)
                        );
                      } else if (newItem.hasOwnProperty("Amount")) {
                        newItem["Amount"] = Number(
                          Number(newItem["Amount"])?.toFixed(2)
                        );
                      }
                      return newItem;
                    }),
                  ]
            }
            columns={columns}
            onActiveCellChange={(res) => {
              setCellState(res);
            }}
            lockRows={disabled}
          />
<h4 style={{ textAlign: "right" }}>Total Amount: {Number(amountValue)?.toLocaleString()}</h4>
         </>
        ) : (
          <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
            <LinearProgress color="info" />
            <LinearProgress color="info" />
            <LinearProgress color="info" />
          </Stack>
        )}

        {/* {!disabled && (
          <Box display="flex" justifyContent={"flex-end"} mt={2}>
            <Button color="secondary" variant="contained" onClick={addInput}>
              Add New Row
            </Button>
          </Box>
        )} */}
        {vendorblock && (
          <POAlertDialog
            setAlertMessage={setvendorblock}
            message={erralertMessage}
            setErrAlertMessage={() => {}}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default Vendor_Table;
